import { trackElement } from '@fff-web/fff-analytics';
import { Button } from '@fff-web/fff-ui-shared';
import { string, bool, func } from 'prop-types';
import env from '../../../utils/env';

const RevealButton = ({ currentBoxName, isMobile, saveRevealState, revealCallback, boxSku }) => (
  <div className="w-100 summary-details">
    {!isMobile && (
      <div className="ta-center">
        <img
          className="reveal-box-image"
          alt="Reveal your box!"
          src={`${env.cfURL}/static/media/box.3a32c684.png`}
        />
      </div>
    )}

    {!isMobile && (
      <div className="lh-lg ta-center ff-ns fs-18 fw-bold">
        Ready to Look Inside Your {currentBoxName} Box?
      </div>
    )}
    <Button
      width="100%"
      style={{ margin: '12px 0 0' }}
      onClick={() => {
        trackElement({
          elementName: 'Reveal Now',
          properties: {
            option_title: `Explore your ${currentBoxName} Box`,
          },
        }).then();
        saveRevealState(boxSku, true).then(revealCallback);
      }}
    >
      Reveal All
    </Button>
  </div>
);

RevealButton.propTypes = {
  currentBoxName: string.isRequired,
  isMobile: bool.isRequired,
  saveRevealState: func.isRequired,
  revealCallback: func.isRequired,
  boxSku: string.isRequired,
};

export default RevealButton;
